export const gatewayOptions = [
  { id: 'payConex', name: 'PayConex' },
  { id: 'payConexPlus', name: 'PayConex Plus' }
];
